// src/components/CalendlyModal.js
import React, { useEffect } from "react"
import "~/styles/calendly-modal.css"




export const CalendlyModal = (props) => {
    const { isOpen, onClose, calendlyUrl } = props;
    
    useEffect(() => {
        const handleKeyDown = (e) => {
        if (e.key === "Escape") onClose()
        }
        document.addEventListener("keydown", handleKeyDown)
        return () => document.removeEventListener("keydown", handleKeyDown)
    }, [onClose])

    if (!isOpen) return null

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <button className="modal-close" onClick={onClose}>✖</button>
                <iframe
                src={calendlyUrl}
                title="Calendly"
                width="100%"
                height="100%"
                frameBorder="0"   
                allowFullScreen
                ></iframe>
            </div>
        </div>
    )
}